export const formStyle = {
  container: "lg:flex flex-wrap flex-col",
  containerLine: "lg:flex py-3 px-6 items-center",
  containerLineTitle: "flex w-full lg:w-[11rem] mr-5 mb-5 lg:mb-0",
  containerLineContent: "grow",
  containerLineContentLoader: "w-full flex justify-center p-4 bg-slate-50 rounded-sm",

  tooltipContainer: "w-5 ml-auto flex items-center justify-center",
  tooltipContainerIcon: "h-5 w-5 text-white dark:text-slate-900 bg-primary rounded-full"
};
